import React from 'react';
import { pricing } from '../data/content';
import { formatArs } from '../utils/format';
export function StickyCta() {
  return <div className="fixed inset-x-0 bottom-0 z-30 border-t border-white/10 bg-forest-deep px-4 py-3 lg:hidden" data-id="element-222" data-mp="3bmx5pdy8fqhc">
      <div className="flex items-center justify-between gap-4" data-id="element-223" data-mp="2xnxlqjlnzzri">
        <div data-id="element-224" data-mp="31n6d5ht8fljw">
          <p className="font-display text-lg font-black leading-none text-cream" data-id="element-225" data-mp="31opsn672dskm">
            {formatArs(pricing.price)}
          </p>
          <p className="text-[11px] text-cream/60" data-id="element-226" data-mp="3pflqajy7bhzs">Pago único · 6 tomos + bonus</p>
        </div>
        <a href="#comprar" className="rounded-lg bg-gold px-5 py-3 font-display text-sm font-extrabold uppercase tracking-wide text-forest-deep transition-colors duration-150 ease-out hover:bg-gold-deep" data-id="element-227" data-mp="3uepzhal4lfq4">
          Lo quiero
        </a>
      </div>
    </div>;
}